import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['dragContainer']

  connect() {
    var dragula = require('dragula');

    this.drake = dragula({
      containers: Array.from(this.dragContainerTargets),
      invalid: (el, handle) => el.classList.contains('no-drag')
    });

    this.drake.on('drop', this.changePosition.bind(this))
  }

  changePosition(el, target, source, sibling) {
    var clientAttrTemplateId = this.dragContainerTarget.getAttribute("data-client-attr-template-id");
    var elementId = el.getAttribute("data-attr-option-id");
    var siblingId = null;

    // input element near the dropped board field
    if(sibling.tagName === "INPUT") {
      sibling = sibling.nextElementSibling
    }
    
    if(sibling !== null) {
      siblingId = sibling.getAttribute("data-attr-option-id");
    }

    let data = { id: elementId, sibling_attribute_id: siblingId, client_attr_template_id: clientAttrTemplateId };

    fetch(`/${accountId}/client_attr_template_opts/${elementId}/update_position`, {
      method: "PATCH",
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if (!response.ok) {
        throw response
      }
      return response.json();
    }).then((responseJson) => {
      responseJson
    }).catch((error) => {
      console.log(error)
    })
  }

}